var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchanges"},[_c('h2',{staticClass:"exchanges-title"},[_vm._v(" Listed Exchanges ")]),_c('div',{staticClass:"exchanges-list"},_vm._l((_vm.list),function(item){return _c('a',{key:item,staticClass:"exchanges-list-item",attrs:{"href":"/","target":"_blank","rel":"noopener noreferrer"}},[_c('i',{class:item})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }